import Klaviyo from '@/components/SignUpForm/Klaviyo';
import KlaviyoView from '@/components/SignUpForm/Klaviyo/BaseFormView';
import EfModal from '@/components/UI/Modal';
import EFGoodDesign from '@/components/UI/svg/Delta2/Icon/EFGoodDesign';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import getHostApi from '@/utils/singUtil/getHostApi';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

const { EFPic } = createEFPic('/media/delta2/h5/');

export default function Comp() {
    const { useState, useEffect, useLang, useRouter, gtm, useRef, getSystemTime } = useGlobal();
    const [showSucc, setShowSucc] = useState(true);
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation.delta2');
    const emailConf = {
        type: 'klaviyo',
        list_id: 'UyDKuB',
        source: 'EcoFlow DELTA2 Teaser from',
        consent_form_id: 'RiEZS8',
    };
    // 切换时间：
    const changeTimeStamp = new Date('2023/10/01 10:00:00 GMT+8').getTime();
    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    // 计时器
    const timer: any = useRef(null);
    // 0: 未到 1: 已过
    const [stage, setStage] = useState(1);

    const onClose = () => {
        // document.querySelector(`.${css.auBanner} form`)?.reset();
        setShowSucc(false);
    };

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTimeStamp.current = getSystemTime();
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }

            let testTimeStamp = 0;
            const localeStorageTime = localStorage.getItem(`timer_delta2_${locale}`);
            if (localeStorageTime && process.env.NEXT_PUBLIC_MODY !== 'prd') {
                testTimeStamp = new Date(localeStorageTime).getTime();
            }

            // 倒计时结束完成之前一直执行定时器任务
            if (serverTimeStamp.current < (testTimeStamp ? testTimeStamp : changeTimeStamp)) {
                timer.current = setInterval(() => {
                    serverTimeStamp.current += 1000;
                    if (serverTimeStamp.current >= (testTimeStamp || changeTimeStamp)) {
                        clearInterval(timer.current);
                        return setStage(1);
                    } else {
                        return setStage(0);
                    }
                }, 1000);
            } else {
                setStage(1);
                clearInterval(timer.current);
            }
            if (typeof window !== 'undefined') {
                window.document.addEventListener('visibilitychange', onVisibleChange);
            }
            return () => {
                clearInterval(timer.current);
            };
        }
    }, []);

    return (
        <div className={`${css.auBanner} au-banner GtmModuleData-section`} data-section-id={css.auBanner} data-section-title={t('title')}>
            <EFPic name={['banner-au.webp', 'banner-au.png']} />
            <div className="icon">
                <EFGoodDesign />,
            </div>
            <div className="text-wrapper">
                {/* <p className="sub-title">{t('banner_au_sub_title')}</p> */}
                <p className="title">{t('title')}</p>
                <p className="slogan">{t('title2')}</p>
                {stage === 0 && <p className="desc">{t('desc')}</p>}
            </div>
            {!showSucc && (
                <Klaviyo
                    extra_properties={{
                        custom_source: emailConf.source,
                        $source: emailConf.source,
                        $method_type: 'Klaviyo Form',
                        $consent_version: 'Embed default text',
                        $consent_form_id: emailConf.consent_form_id,
                    }}
                    successCallback={() => {
                        setShowSucc(true);
                        try {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_submit',
                                button_name: t('banner_au_email_btn'),
                                product_name: 'EcoFlow DELTA2',
                                status: 'success',
                            });
                            /** @ts-ignore */
                            window?.fbq && window?.fbq('track', 'Lead');
                        } catch (e) {
                            console.error(e);
                        }
                    }}
                    errorCallback={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'activity_submit',
                            button_name: t('banner_au_email_btn'),
                            product_name: 'EcoFlow DELTA2',
                            status: 'fail',
                        });
                    }}
                >
                    <KlaviyoView list_id={emailConf.list_id} submitText={t('banner_au_email_btn')} placeholder={t('banner_au_email_tip')} />
                </Klaviyo>
            )}
            <EfModal
                visible={false}
                onCancel={onClose}
                width={'100%'}
                className="delta2-email-sign-up"
                maskStyle={{ background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.40) 2.95%, rgba(0, 0, 0, 0.70) 43.3%, rgba(0, 0, 0, 0.93) 100%)' }}
                maskClosable
            >
                <p className="content">{t('banner_au_email_succ')}</p>
            </EfModal>
            <style jsx global>
                {`
                    .delta2-email-sign-up {
                        .ant-modal-content {
                            position: relative;
                            width: 100%;
                            background-color: unset;
                            box-shadow: unset;

                            .ant-modal-close {
                                display: none;
                            }

                            .content {
                                position: absolute;
                                width: max-content;
                                margin-top: 60vh;
                                left: 50%;
                                transform: translateX(-50%);
                                font-size: 0.18rem;
                                line-height: 1.35;
                                font-family: var(--font-family-Medium);
                                color: #fff;
                                letter-spacing: 0;
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
}
